import moment from 'moment';

import { IMAGE_SIZE } from '@api/media/constants';
import * as utils from '@utils/form';

export const FORM_FIELD = {
  NAME: {
    name: 'name',
    label: 'Campaign Name:',
    placeholder: 'Enter a name',
    rules: [{ required: true, message: 'Name is required' }],
  },
  TAG: {
    name: 'tag',
    label: 'Campaign Tag:',
    placeholder: 'Enter a tag',
    rules: [{ required: true, message: 'Tag is required' }],
  },
  FRIENDLY_NAME: {
    name: 'tagUserFriendlyName',
    label: 'User friendly name:',
    placeholder: 'Enter a friendly name',
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Campaign description:',
    placeholder: 'Enter a description',
    rules: [{ required: true, message: 'Description is required' }],
  },
  THANK_YOU_MESSAGE: {
    name: 'thankYouMessage',
    label: 'Campaign thank you message:',
    placeholder: 'Enter a thank you message',
    rules: [{ required: true, message: 'Thank you message is required' }],
  },
  ALREADY_SIGNED_MESSAGE: {
    name: 'alreadySignedMessage',
    label: 'Campaign already signed message:',
    placeholder: 'Enter an already signed message',
    rules: [{ required: true, message: 'Already signed message is required' }],
  },
  CLOSE_DATE: {
    name: 'closeDate',
    label: 'Campaign close date:',
    rules: [{ required: true, message: 'Close date is required' }],
    serialize: (field, values) => {
      const value = values[field.name];

      if (value) return { [field.name]: value.toISOString() };
      return { [field.name]: '' };
    },
    deserialize: (field, serverData) => {
      const value = serverData[field.name];

      if (serverData[field.name]) {
        return {
          [field.name]: moment(Date.parse(value)),
        };
      }
      return {};
    },
  },
  PREFERENCE_CENTRE: {
    name: 'visibleOnPreferenceCenter',
    label: 'Visible on preference centre',
  },
  SHORT_FORM: {
    name: 'shortForm',
    label: 'Short form',
  },
  REDIRECT_URL: {
    name: 'redirectUrl',
    label: 'Redirect url:',
    placeholder: 'Enter a redirect url',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  DOWNLOAD: {
    name: 'downloadUserData',
    buttonText: 'DOWNLOAD USER DATA',
  },
  HEADER: {
    name: 'headerImage',
    label: 'Header:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'Logo is required' }],
    size: IMAGE_SIZE['700x220'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  BACKGROUND: {
    name: 'backgroundImage',
    label: 'Background:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'Logo is required' }],
    size: IMAGE_SIZE['2000x1333'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  BUCKETSELECT: {
    name: 'topLevelBucketId',
    label: 'Top Buckets:',
  },
};

export const BUCKETS = [
  {
    id: '61eaa3e6850c51a1e3d63233',
    label: 'Education',
  },
  {
    id: '61eaa3e6850c51a1e3d63234',
    label: 'Events (Tickets, news)',
  },
  {
    id: '61eaa3e6850c51a1e3d63235',
    label: 'Exclusive Offers & News',
  },
  {
    id: null,
    label: 'None',
  },
];
